const style = {
  cursor: "pointer",
  backgroundColor: "#50F050",
  border: 0,
  borderRadius: 10,
  outline: "solid 1px #909090",
  padding: 4,
  width: 24,
  height: 24
};

export function CreateButton(props) {
  return (<>
    <button style={ style } onClick={ props.onClick }>
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
      </svg>
    </button>
  </>);
}
